import { User } from "../models/user";

const initialState: User = {
  hasTutorialShow: false,
  email: "",
  uid: "",
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case "HAS_TUTORIAL_SHOW":
      return {
        ...state,
        hasTutorialShow: true,
      };
    case "SET_USER_DATA":
      return {
        ...state,
        [action.key]: action.data,
      };
    case "DELETE_ALL_USER_DATA":
      return {
        ...state,
        email: null,
        uid: null,
      };
    default:
      return state;
  }
}
